import axios from 'axios'

const MdtDao = {
  async list () {
    const url = '/groupMdt/mine/list'
    const { data: resp } = await axios.get(url)
    const {
      code,
      data
    } = resp
    if (code !== 200 || !data) {
      return null
    }
    return data
  }
}
export default MdtDao
